<template>
    <div>
        <!-- Breadcrumb Section Start -->
        <section class="breadscrumb-section pt-0">
            <div class="container-fluid-lg">
                <div class="row">
                    <div class="col-12">
                        <div class="breadscrumb-contain">
                            <h2>{{ $t('Product') }}</h2>
                            <nav>
                                <ol class="breadcrumb mb-0">
                                    <li class="breadcrumb-item active" aria-current="page">{{ $t('Product') }}</li>
                                    <li class="breadcrumb-item">
                                        <router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >
                                            <i class="fa-solid fa-house"></i>
                                        </router-link>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Breadcrumb Section End -->

        <!-- Cart Section Start -->
        <section class="cart-section section-b-space">
            <div class="container-fluid-lg">

                <div class="row g-sm-5 g-3" v-if="cartItems?.length > 0">
                    <div class="col-xxl-9">

                        <h3 class="mb-1"> محتويات صندوق المنتجات </h3>

                        <div class="cart-table mb-4">
                            <div class="table-responsive-xl">
                                <table class="table">
                                    <tbody>
                                    <tr class="product-box-contain" v-for="cartItem in cartItems" :key="cartItem.id">
                                        <td class="product-detail">
                                            <div class="product border-0">
                                                <router-link :to="{name: 'products.show', params: { id: cartItem.product.id , lang : $i18n.locale  }}"
                                                             class="product-image">
                                                    <img :src="cartItem.product.image ?? '/theme/assets/images/more/product-card.png'"
                                                         class="img-fluid blur-up lazyload" alt="">
                                                </router-link>
                                                <div class="product-detail">
                                                    <ul>
                                                        <li class="name">
                                                            <router-link :to="{name: 'products.show', params: { id: cartItem.product.id , lang : $i18n.locale  }}"
                                                                         class="product-image">
                                                                {{ cartItem.product.name }}
                                                            </router-link>
                                                        </li>

                                                        <li v-if="cartItem.selected_price !== null">
                                                            <span>{{ cartItem.selected_price.name }}</span>
                                                        </li>

                                                        <li>
                                                            <h5 class="text-content d-inline-block">{{ $t('Price') }} :</h5>
                                                            <span>{{ cartItem.selected_price?.price_tax || cartItem.product.price_tax }} {{ $t('priceSymbol') }}</span>
                                                        </li>
                                                    </ul>

                                                    <div class="text-content" v-for="(attribute, attributeId) in cartItem.product.attributes" :key="attributeId">
                                                        <span class="text-title"> {{ attribute?.data?.name }} : </span>
                                                        <span>{{ getSelectedAttributeValue(attributeId, cartItem) }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        <td class="quantity">
                                            <h4 class="table-title text-content">{{ $t('Qty') }}</h4>

                                            <CartButton v-if="cartItem.product" :product="cartItem.product" :cart="cartItem" :type="'small-icon'"></CartButton>

                                        </td>

                                        <td class="subtotal">
                                            <h4 class="table-title text-content">{{ $t('Total') }}</h4>
                                            <h5>{{
                                                    parseFloat((cartItem.quantity || 0) * (cartItem.selected_price?.price_tax || cartItem.product.price_tax || 0)).toFixed(2)
                                                }} {{ $t('priceSymbol') }}</h5>
                                        </td>

                                        <td class="save-remove" width="35">
                                            <a class="close_button btn btn-light btn-sm text-danger" @click="removeFromCart(cartItem?.id)">{{ $t('Remove') }}</a>
                                        </td>
                                    </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>

                    <div class="col-xxl-3">
                        <div class="summery-box p-sticky">
                            <div class="summery-header">
                                <h3>{{ $t('Cart Total')}}</h3>
                            </div>

                            <div class="summery-contain">
                                <ul>
                                    <li>
                                        <h4>{{ $t('Subtotal')}}</h4>
                                        <h4 class="price">{{ subtotal }} {{ $t('priceSymbol') }}</h4>
                                    </li>
                                    <li>
                                        <h4> {{ $t('Shipping and delivery') }} </h4>
                                        <h4 class="price">{{ main.settings?.shipping_cost }} {{ $t('priceSymbol') }}</h4>
                                    </li>
                                    <li class="text-muted">
                                        <h4>{{ $t('Tax')}}</h4>
                                        <h4 class="price">{{ tax }} {{ $t('priceSymbol') }}</h4>
                                    </li>
                                </ul>
                            </div>

                            <ul class="summery-total">
                                <li class="list-total border-top-0">
                                    <h4> {{ $t('Total') }} : </h4>
                                    <h4 class="price theme-color">{{ total }} {{ $t('priceSymbol') }}</h4>
                                </li>
                            </ul>

                            <div class="button-group cart-button">
                                <ul>
                                    <li>
                                        <router-link :to="{name: 'checkout', params: { lang : $i18n.locale  }}"
                                                     class="btn btn-animation proceed-btn fw-bold">
                                            {{ $t('Proceed to checkout') }}
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="alert alert-danger" v-else>
                    {{ $t('No items in product') }}
                </div>

                {{main?.settings?.name ?? '55'}}
            </div>
        </section>
        <!-- Cart Section End -->
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CartButton from "./CartButton.vue";

export default {
    components: { CartButton },
    props: ['main'],
    created() {
        window.scrollTo(0, 0);
        // Dispatch action to set main settings in the store
    },
    watch: {
        main: {
            handler: function (val) {
                this.setMainSettings(this.main.settings);
            },
            deep: true,
        },
    },
    computed: {
        ...mapGetters(['cartItems', 'getSelectedAttributeValue', 'subtotal', 'tax', 'total']), // ربط getters مع المكون
    },
    methods: {

        ...mapActions(['addToCart', 'removeFromCart','setMainSettings']),
    },
};
</script>
